import { BookOpenTextIcon, FileTextIcon, PillIcon, SearchIcon, ShirtIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Bonus = {
  number: string;
  title: string;
  description: string;
  icon: LucideIcon;
};

export const bonuses: Bonus[] = [
  {
    number: '1',
    title: 'Good Documentation Practice (GDocP) Quick Guide',
    description: 'A fast visual reference to recording, correcting and reviewing GMP entries.',
    icon: FileTextIcon,
  },
  {
    number: '2',
    title: 'Deviation Investigation & Root Cause Analysis Field Guide',
    description: 'A structured reference to describing deviations and working through root cause analysis.',
    icon: SearchIcon,
  },
  {
    number: '3',
    title: 'Cleanroom Gowning & Aseptic Behavior Visual Guide',
    description: 'Step-by-step visuals of gowning sequences and correct behavior in clean areas.',
    icon: ShirtIcon,
  },
  {
    number: '4',
    title: 'Tablet, Capsule & Coating Defects Troubleshooting Atlas',
    description: 'Common tablet, capsule and coating defects with their typical causes.',
    icon: PillIcon,
  },
  {
    number: '5',
    title: 'Pharmaceutical Manufacturing & GMP Terminology Dictionary',
    description: 'An A–Z reference of the terms and acronyms used in pharmaceutical manufacturing and GMP.',
    icon: BookOpenTextIcon,
  },
];
